import styled from "styled-components";

import { fonts } from "../../../styles/variables";
import Button from "../../atoms/Button";

export const Body = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-size: 15px;
  line-height: 1.4;

  p {
    margin: 0 0 10px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 24px;
`;

export const ConfirmButton = styled(Button)``;

export const CancelButton = styled(Button)``;
